import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { currencySymbols } from "../../constants";
import { useCurrency } from "../../Context/CurrencyContext";

const CurrencyDropdown = () => {
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const { updateRate } = useCurrency();

  useEffect(() => {
    const fetchCurrencies = () => {
      const currencyData = localStorage.getItem("currencyData");
      if (currencyData) {
        try {
          const { rates } = JSON.parse(currencyData);
          const formattedCurrencies = Object.entries(rates)
            .map(([currency, rate]) => ({ currency, rate }))
            .sort((a, b) => a.currency.localeCompare(b.currency));
          setCurrencies(formattedCurrencies);
        } catch (error) {
          console.error("Invalid currency data in localStorage", error);
        }
      }
    };

    const storedCurrency = localStorage.getItem("selectedCurrency");
    if (storedCurrency) setSelectedCurrency(storedCurrency);
    fetchCurrencies();
  }, []);

  const handleCurrencyChange = (event) => {
    const selected = event.target.value;
    localStorage.setItem("selectedCurrency", selected);
    setSelectedCurrency(selected);
    const selectedCurrencyData = currencies.find(
      (c) => c.currency === selected
    );
    if (selected === "USD") updateRate({ $: 1 });
    else if (selectedCurrencyData) {
      const symbol = currencySymbols[selected];
      updateRate({ [symbol]: selectedCurrencyData.rate });
    }
  };

  return (
    <FormControl
      sx={{
        flexShrink: 1,
        // allow a bit of horizontal growth to fit code
        minWidth: { xs: 60, sm: 80 },
        marginLeft: 0,
        overflow: "visible",
        "& .MuiInputBase-root:before, & .MuiInputBase-root:after": {
          display: "none",
        },
      }}
    >
      <Select
        labelId="currency-select-label"
        value={selectedCurrency}
        onChange={handleCurrencyChange}
        renderValue={(value) => value}
        variant="standard"
        disableUnderline
        MenuProps={{
          disablePortal: true,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: {
              maxHeight: 220,
              boxSizing: "border-box",
              mt: 0.5,
            },
          },
        }}
        sx={{
          height: "40px",
          backgroundColor: "white",
          borderRadius: "4px",
          width: "auto",
          minWidth: 0,
          border: "none",
          boxShadow: "none",
          outline: "none",
          fontSize: { xs: "14px", sm: "16px" },
          pl: 0,
          pr: 1,
          ml: 0,
          whiteSpace: "nowrap",
        }}
      >
        <MenuItem
          value="USD"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            minWidth: { xs: 60, sm: 80 },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <span>USD</span>
        </MenuItem>
        {currencies.map(({ currency }) => (
          <MenuItem
            key={currency}
            value={currency}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <span>{currency}</span>
            <span>{currencySymbols[currency]}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencyDropdown;
